import config from 'shared/config';
import connector from 'api/http';
import { ApiData, BsbDetails } from 'scenes/common/types';
import { makeApiSuccess, makeApiError } from 'scenes/common/helpers/apiData';

const bsbApi = (baseUrl: string = config.baseUrls.BFF_BASE_URL) => {
  const server = connector(baseUrl);

  return {
    getBsbDetails: (query: string): Promise<ApiData<BsbDetails>> =>
      server
        .get('/bsb/lookup', {
          bsb: query,
        })
        .then(({ bsb, name, branchAddress, branchPostcode }) =>
          makeApiSuccess({
            bsb,
            bankName: name,
            branchAddress,
            branchPostcode,
          })
        )
        .catch(() => makeApiError('Sorry, we cannot find the BSB.')),
  };
};

export default bsbApi;
